
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#798f8f"}},[_c('path',{staticClass:"i-stroke",attrs:{"d":"M3.5 8.492a.996.996 0 0 1 1-.992h8c.552 0 1 .444 1 .992v6.016a.996.996 0 0 1-1 .992h-8c-.552 0-1-.444-1-.992V8.492Z"}}),_c('path',{staticClass:"i-stroke_2",attrs:{"d":"M5.5 7V4.556c0-.81.316-1.588.879-2.161A2.973 2.973 0 0 1 8.5 1.5c.796 0 1.559.322 2.121.895.563.573.879 1.35.879 2.16V7","stroke-linecap":"round","stroke-linejoin":"round"}})])])
          )
        }
      }
    